import React from 'react';
import classNames from 'classnames/bind';
import Image from 'next/image';
import { getAuthorProfileImageSrc } from '../../utils/postInfo';
import Author from '../../types/author';
import { PostDesignType } from '../../types/post';
import styles from './ProfileCard.module.scss';

const cx = classNames.bind(styles);

export type ProfileCardProps = {
  children: React.ReactNode;
  designType: PostDesignType;
  author: Author;
};

function ProfileCard({ children, designType, author }: ProfileCardProps): JSX.Element {
  const profileImageSrc = getAuthorProfileImageSrc(author.profileImage);
  const name = author.name ? author.name : author.team; // 작성자명이 없을 경우 팀명으로 대체

  return (
    <div className={cx('profile_card')}>
      {/* [D] 들어가는 문양에 따라 '-case1' ~ '-case4' 까지 클래스 추가해주세요 */}
      <div className={cx('profile_image_area', `-case${designType}`)}>
        <div className={cx('profile_image_wrap')}>
          <Image src={profileImageSrc} alt={'profile image'} width={138} height={138} objectFit="cover" priority />
        </div>
      </div>
      <div className={cx('profile_info_area')}>
        <div className={cx('profile_name_wrap')}>
          {/* 작성자명은 없고 팀명만 있을 경우, 작성자 칸에 팀명을 표시하고 팀명 칸은 숨김 처리 */}
          <strong className={cx('profile_name')} data-testid="author-name">
            {name}
          </strong>
          {author.name && (
            <p className={cx('profile_team')} data-testid="team-name">
              {author.team}
            </p>
          )}
        </div>
        <div className={cx('profile_description')}>{children}</div>
      </div>
    </div>
  );
}

export default ProfileCard;
